import { render, staticRenderFns } from "./ProjectImportDialog.vue?vue&type=template&id=49332388"
import script from "./ProjectImportDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectImportDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports